import { createRoot } from "react-dom/client";
import App from "./App.tsx";
import "./index.css";

// FRISYRE_OS is single-mode TUI dark — force the .dark class once.
document.documentElement.classList.add("dark");

createRoot(document.getElementById("root")!).render(<App />);
